// src/components/ProductInfoModal.tsx
import React from "react";

interface Props {
  product: any;
  show: boolean;
  onClose: () => void;
}

export default function ProductInfoModal({ product, show, onClose }: Props) {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex={-1}
      role="dialog"
      style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content shadow">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">📦 Product Information</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">Name</th>
                  <td>{product.name}</td>
                </tr>
                <tr>
                  <th scope="row">Brand</th>
                  <td>{product.brand}</td>
                </tr>
                <tr>
                  <th scope="row">Price</th>
                  <td>{product.price} ETB</td>
                </tr>
                <tr>
                  <th scope="row">Age Range</th>
                  <td>{product.min_age} – {product.max_age}</td>
                </tr>
                <tr>
                  <th scope="row">Description</th>
                  <td>{product.description ?? "No description available"}</td>
                </tr>
                <tr>
                  <th scope="row">Stock</th>
                  <td>{product.stock ?? "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="modal-footer no-print">
            <button className="btn btn-outline-primary btn-sm" onClick={handlePrint}>
              🖨 Print
            </button>
            <button className="btn btn-outline-secondary btn-sm" onClick={onClose}>
              🔄 Close
            </button>
            <button className="btn btn-outline-success btn-sm" disabled>
              📥 Export (coming soon)
            </button>
          </div>
        </div>
      </div>

      {/* ✅ CSS to hide buttons when printing */}
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>
    </div>
  );
}

